import { FunctionComponent } from 'react'
import styled, { css } from 'styled-components'

export interface TitleProps {
  children: string
}

const Wrapper = styled.div`
  ${({
    theme: {
      colors: { textDefault },
      typography: {
        headings: {
          xsmall: { bundledCSS: xsmallHeadingCSS },
        },
      },
      utils: { ellipsis },
    },
  }) => css`
    ${ellipsis('100%', 4)};
    ${xsmallHeadingCSS};
    line-height: 1.4;
    color: ${textDefault};
  `}
`
const StyledTitle = styled.span`
  ${({
    theme: {
      colors: { fillDefault },
      spacing: { spacing4, spacing2, spacing12 },
    },
  }) => css`
    background-color: ${fillDefault};
    padding: 0 ${spacing4} ${spacing2};

    display: inline;
    box-decoration-break: clone;
    -webkit-box-decoration-break: clone;

    word-break: break-word;
    box-shadow: ${spacing12} 0 0 ${fillDefault};
  `}
`

const Title: FunctionComponent<TitleProps> = ({ children }) => {
  return (
    <Wrapper>
      <StyledTitle>{children}</StyledTitle>
    </Wrapper>
  )
}

export default Title
